export default __webpack_public_path__ + "static/media/order.3a97bcae.svg";